import { gql } from '@apollo/client';
import surveyQueryFragment from './surveyQueryFragment';

const UPDATE_SURVEY_RESULTS = gql`
  mutation updateSurveyResults($input: [SurveyResultValueUpdateInput!]!) {
    updateSurveyResults(editedSurveyResults: $input) {
      ...SurveyFields
    }
  }
  ${surveyQueryFragment}
`;

export default UPDATE_SURVEY_RESULTS;
